import { resolveNyafazReelsBase, resolveNyafazReelsLogin } from '../../nyafaz_reels/paths';

/** Canonical SPA base for Naturals reels capture (JSON2Video). */
export const REELS_BASE = '/naturals/reels';
export const REELS_LOGIN = '/naturals/reels/login';

/** Legacy path — keep redirects only. */
export const LEGACY_VIDEO_BASE = '/naturals/video';

function activeReelsBase() {
  if (typeof window !== 'undefined' && window.location.pathname.includes('/nyafaz-reels')) {
    return resolveNyafazReelsBase();
  }
  return REELS_BASE;
}

function activeReelsLogin() {
  if (typeof window !== 'undefined' && window.location.pathname.includes('/nyafaz-reels')) {
    return resolveNyafazReelsLogin();
  }
  return REELS_LOGIN;
}

export function reelsHomePath() {
  return activeReelsBase();
}

export function reelsPath(...parts) {
  const base = activeReelsBase();
  const suffix = parts
    .filter((p) => p != null && String(p).length)
    .map((p) => String(p).replace(/^\/+|\/+$/g, ''))
    .join('/');
  return suffix ? `${base}/${suffix}` : base;
}

export { activeReelsLogin as reelsLoginPath };
